import React from 'react'

import Img1 from "../../assets/images/charnouzies_female_male.png"
import Img2 from "../../assets/images/Bot.png"
import Img3 from "../../assets/images/nitchy.png"
import Img4 from "../../assets/images/jaboulah.png"
import Img5 from "../../assets/images/humans.png"
import Img6 from "../../assets/images/Zorgos.png"
import Img7 from "../../assets/images/MALTASSAR.png"
import Img8 from "../../assets/images/PANKARS.png"
import Img9 from "../../assets/images/PANKARS.png"
import Img10 from "../../assets/images/FROOZKI.png"
import Img11 from "../../assets/images/CHIBICHIBI.png"
import Img12 from "../../assets/images/GOONOONOO.png"
import Img13 from "../../assets/images/wongo.png"

import "./Species.scss"
import Footer from '../Footer/Footer'

const Species = () => {
    return (
        <>
            <div className='species_container'>
                <div className="box">
                    <div className="heading_box">
                        <div className="heading"> SPECIES FROM ALL THE METAVERSE </div>
                        <div className="detail">Meet the 12 species of the Nilmara Galaxy</div>
                        <div className="para">The civilisations living in the Nilmara Galaxy are very different, physically and culturally, yet they are pretty complementary.</div>
                    </div>
                    <div className="cards_box">
                        <div className="mcard">
                            <div className="img_box"> <img src={Img1} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">CHARNOUZY</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">Charnouzies are not a very developed species. They are known to steal huge quantities of water wherever they can, water being their main source of energy. Two gender: female and male.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Gatnatar, a tiny and very hot planet.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img2} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">BOTOTO</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">They are enhanced beings with bionic parts making them the most advanced species in terms of computational power.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on an artificial planet called Artura Z-201.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img3} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">NITCHY</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">A barbarian species known to be very fearsome warriors. Their civilisation is yet not very developed. Only one gender.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Dandolo, a very dry and vast planet.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img4} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">JABOULAH</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">A very funny and warm species. They are very welcoming and love every type of amusement like sports and games.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Malakah, a hot and full of life planet.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img5} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">HUMAN</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">They have wonderful artistic abilities, a very good sense of humor, and are very emotive. They are a semi-developed civilisation with big social disparities between themselves. Two genders species: Female & Male.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">Humans are living on Earth, the planet hosting the well known Sandaga Central Market.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img6} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">ZORGOS</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">A very peaceful and open minded species which communicates telepathically. They don't really work, they devote most of their time to become better beings, mainly through meditation and physical activity.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on the very quiet planet Zayzin.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img7} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">MALTASSAR</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">The most powerful and advanced civilization of the Galaxy of Nilmara.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Maltass and its three moons.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img8} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">PANKARS</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">They are very organized and everyone is involved in the army (everyone). They have a very particular type of humor and they happen to be a very cruel species, mostly between themselves. Two genders species: Female & Male.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Pankora and its moon.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img9} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">FROOZKI</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">They care a lot about physical appearance and feel superior to other species. They enjoy having fun and produce the best beers in the entire Galaxy: the Glooz.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on the very colorful planet of Froozkimo.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img10} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">CHIBICHIBI</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">They are a very archaic tribe who hasn’t yet discovered most of the basic technologies, still the Alliance is making sure to help them. They believe in multiple gods and have a strong faith.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on the cold planet Makabala.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img11} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">GOONOONOO</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">Goonoonoos are the most loved beings in the Galaxy because of their natural charm. Two genders: Female and Male.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Foorara, an oval shaped and very cold planet with a huge volcanic activity.</div>
                            </div>
                        </div>
                        <div className="mcard">
                            <div className="img_box"> <img src={Img12} alt="ERROR" /> </div>
                            <div className="data">
                                <div className="title">WONGO</div>
                                <div className="question">Who are they?</div>
                                <div className="detail">A smart yet not really demonstrative species. They appreciate all sorts of amusement and are very open to other species. They are not far behind the Maltassars in terms of technological advances.</div>
                                <div className="question2">Where they come from ?</div>
                                <div className="detail">They live on Wongodi, an iced planet.</div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <Footer />
        </>
    )
}

export default Species
